module.exports = "<search *ngIf=\"default | async as search\" [content]=\"search.rows\" [meta]=\"(search | meta)\" class=\"container\"></search>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/search-container/search-container.template.html
// module id = 878
// module chunks = 2